import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { invInput, invField, errMsg } from './invApi';

const CatRow = ({ c, api, fallback }) => {
  const [m, setM] = useState(c.margin_percent ?? '');
  const save = async () => {
    try {
      await api.patch(`/categories/${c.id}`, m === '' ? { clear_margin: true } : { margin_percent: Number(m) });
      toast.success(`${c.name} : ${m === '' ? `marge de la charte (${fallback} %)` : `+${m} %`}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex items-center gap-3 bg-slate-900 border border-slate-800 rounded-xl px-4 py-3" data-testid={`category-${c.id}`}>
      <span className="flex-1 text-sm text-white">{c.name}</span>
      <span className="text-xs text-slate-500">+</span>
      <input type="number" className={`${invField} w-24 text-right`} placeholder={`${fallback}`} value={m} onChange={e => setM(e.target.value)} onBlur={save} data-testid={`category-margin-${c.id}`} />
      <span className="text-xs text-slate-500">%</span>
    </div>
  );
};

export const CategoriesTab = ({ api, fallback = 0 }) => {
  const [cats, setCats] = useState([]);
  const [name, setName] = useState('');
  const load = () => api.get('/categories').then(setCats);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const add = async () => { try { await api.post('/categories', { name }); setName(''); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-2 max-w-xl" data-testid="inventory-categories-tab">
      <p className="text-xs text-slate-500">Prix de vente = coût d'achat + marge de la catégorie. Laissez vide pour utiliser la majoration de la charte de prix.</p>
      {cats.map(c => <CatRow key={c.id} c={c} api={api} fallback={fallback} />)}
      <div className="flex gap-2 pt-2">
        <input className={invInput} placeholder="Nouvelle catégorie" value={name} onChange={e => setName(e.target.value)} data-testid="category-new-name" />
        <button onClick={add} disabled={!name.trim()} className="px-4 rounded-lg bg-amber-500 text-black text-sm font-semibold disabled:opacity-40" data-testid="category-new-save">Ajouter</button>
      </div>
    </div>
  );
};
